export default __webpack_public_path__ + "static/media/telegram_white.de2e6ec7.svg";